module.exports = __webpack_public_path__ + "mz.svg?dec9e7e66f2dbe73dd7e5ee3ebad7736";